export const engageAgentRootPath = '/agent';
export const takeActionRootPath = '/take-action';
